var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.57578,0H2.42452c-.1328,0-.26078,.01838-.38781,.03882C.88326,.22346,0,1.20607,0,2.40014V10.8001c0,1.32553,1.08531,2.39999,2.42422,2.39999h30.30281v-.00015h4.84874c1.3364,0,2.42422-1.07695,2.42422-2.39999V2.39999c0-1.32304-1.08782-2.39999-2.42422-2.39999Zm0,10.79996h-4.84845V2.39999h4.84845V10.79996Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.57578,22.79991H2.42452c-.1328,0-.26078,.01838-.38781,.03882-1.15344,.18464-2.03671,1.16726-2.03671,2.36132v8.39997c0,1.32553,1.08531,2.39999,2.42422,2.39999H15.75746v-.00015h21.81832c1.3364,0,2.42422-1.07695,2.42422-2.39999v-8.39997c0-1.32304-1.08782-2.39999-2.42422-2.39999Zm0,10.79996H15.75776v-8.39997h21.81802v8.39997Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.953c1aefc703bca105eb4162e689e888.svg";
export { ForwardRef as ReactComponent };